/* tslint:disable */
/* eslint-disable */
/**
 * K·HERO
 * K·HERO API documentation
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

/**
 * What to do with the events already scheduled from this session. When the session is referenced and this is omitted, the request is refused with 428 Precondition Required (SESSION.UPDATE_REQUIRES_CONFIRMATION); read the impact from GET /sessions/:id/references, then resend the identical body with a strategy. `propagate` rewrites those events to the new version; `keep-scheduled` leaves them exactly as prescribed and the edit reaches only future assignments. Ignored when nothing is scheduled.
 * @export
 * @enum {string}
 */
export enum EnSessionUpdateStrategy {
    Propagate = 'propagate',
    KeepScheduled = 'keep-scheduled'
}

